import styled from "styled-components";
import { Type as TypeRCL } from "discover.medical.react-component-library";

export const Type = styled(TypeRCL)`
  em {
    font-style: italic;
  }

  sup {
    font-size: ${(props) => props.theme.font.size.xs};
    vertical-align: super;
  }
`;
